import type { OrderSubscriptionType } from '@/types/order'
import { Chip, type SxProps } from '@mui/material'

// Postfix conventions come from e-pharmacy-api numbering_service:
// #CHAIN → subscription parent record
// #LINK#N / #SUB#N → subscription iteration; N=1 is the initial order, N>1 is a renewal
export function deriveOrderLabel(subscriptionType: OrderSubscriptionType, orderNumber: string): string {
  if (subscriptionType === 'shop_subscription') return 'Subscription plan'
  if (subscriptionType === 'shop_order_refund') return 'Refund'

  if (orderNumber.includes('#CHAIN')) return 'Chain order'
  if (orderNumber.includes('#MPSMED#')) return 'Medication order'
  if (orderNumber.includes('#MPSORD#')) return 'Subscription billing order'
  if (orderNumber.includes('#MPS')) return 'Subscription plan'

  const linkMatch = orderNumber.match(/#LINK#(\d+)/)
  if (linkMatch) {
    return Number.parseInt(linkMatch[1], 10) >= 2 ? 'Subscription renewal' : 'Initial subscription order'
  }

  if (orderNumber.includes('#SUB#')) return 'Initial subscription order'

  return 'One-time order'
}

export default function OrderSubscriptionTypeChip({
  subscriptionType,
  orderNumber,
  sx
}: {
  subscriptionType: OrderSubscriptionType
  orderNumber: string
  sx?: SxProps
}) {
  return (
    <Chip
      label={deriveOrderLabel(subscriptionType, orderNumber)}
      size='small'
      sx={{
        color: '#4E545E',
        borderColor: '#4E545E',
        backgroundColor: 'white',
        borderRadius: '16px',
        border: '1px solid',
        ...sx
      }}
    />
  )
}
